import React from 'react';

export const PullQuote = ({ children, className = '' }) => {
  return (
    <blockquote className={`pull-quote ${className}`}>
      {children}
    </blockquote>
  );
};

export const Callout = ({ title, children, className = '' }) => {
  return (
    <div className={`callout ${className}`}>
      {title && <div className="callout-title">{title}</div>}
      <div className="text-foreground">{children}</div>
    </div>
  );
};

export const SectionDivider = ({ className = '' }) => {
  return <hr className={`section-divider ${className}`} />;
};

export default PullQuote;
